function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "text_bubble",
  "data-name": "text bubble"
}, /*#__PURE__*/React.createElement("path", {
  d: "M575.39,87.38c-4.62-42-54.43-90.29-213.1-86.13-50.17.45-122,8-163.41,18.72C125.39,40,94.38,88.39,114.46,130.61c.26.52.55,1,.84,1.53C101.32,146,55.16,168.81.39,192.23c13.3-4.12,25.22-8.51,42.92-13.62,16.25-4.47,49.42-20.38,54.59-23,9.4-4.52,16.63-7.87,26.06-12.41,15.11,14.89,41.17,25.37,70.84,30.95,55.43,10.41,204.06,14.61,271,0C514.67,166.68,580,129.38,575.39,87.38Z",
  fill: "#fffdf5",
  stroke: "#2d2d2d",
  strokeMiterlimit: 10,
  strokeWidth: 2
})));

function SvgBubble2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.63 193.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bubble2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble2);
export default __webpack_public_path__ + "static/media/bubble2.c4a7c656.svg";
export { ForwardRef as ReactComponent };